import Vue from 'vue'
import Vuex from 'vuex'
import $api from '@/components/api.js';

Vue.use(Vuex);

const newProductCatalog = {id: "new-products-catalog-id", is_active: true, name: "Новинки", slug: "new-products"};

export const store = new Vuex.Store({
    state: {
        distributors: [],
        cultures: [],
        products: [],
        newProducts: [],
        catalogs: [],
        managers: [],
        diseases: [],
        articles: [],
        field_news: [],
        cultures_by_category: [],
        diseases_by_culture: [],
        protection: [],
        regions: [],
        videos: [],
        promos: [],
        slides: [],
        pests: [],
        weeds: [],
        news: [],
        searchProducts: [],
        settings: {isEmpty: true},
        crop: [],
        activeCulture: {},
        withBanner: true,
        desk: true,
    },
    mutations: {
        SET_COLLECTION: (state, payload) => {
            state[payload.name] = payload.data;
        },
        clearSearch: (state) => {
            state.searchProducts = [];
        },
        SET_CROP: (state, payload) => {
            state.crop = payload;
        },
        SET_ACTIVE_CULTURE: (state, payload) => {
            state.activeCulture = payload;
        },
        SET_BANNER: (state, payload) => {
            state.withBanner = payload;
        },
        SET_DESKTOP: (state, payload) => {
            state.desk = payload;
        }
    },
    getters: {
        chooseColor: (state) => (id) => {
            if(state.products.length && state.catalogs.length) {
                let p = state.products.filter(item => item.id == id);
                let cat = state.catalogs.filter(item => item.id == p.catalogs[0]);
                return cat.color;
            }
           
        },
        getProductsForIndex: (state) => {
            let arr = state.products.filter(item => item.show_on_index === true);
            arr.forEach(item => {
                let catalog = state.catalogs.find(c => c.id === item.catalogs[0]);
                if (catalog) item.category = {name: catalog.name, color: catalog.color}
            });
            return arr;
        },
        getNewProductsForIndex: (state) => {
            let arr = state.newProducts.filter(item => item.is_new === true);
            arr.forEach(item => {
                let catalog = state.catalogs.find(c => c.id === item.catalogs[0]);
                if (catalog) item.category = {name: catalog.name, color: catalog.color}
            });
            return arr;
        },
        getProductsByCulture: (state) => (id) => {
            if (!id) return [];
            let arr = state.products.filter(item => {
                let obj = item.cultures.find(c => c === id);
                return obj != undefined;
            });
            arr.forEach(item => {
                let catalog = state.catalogs.find(c => c.id === item.catalogs[0]);
                if (catalog) item.category = {name: catalog.name, color: catalog.color}
            });
            return arr;
        },
        getMaterialsByCulture: async (state) => (id) => {
            if (!id) return [];
            // let {data} = await $api.getCultureById(id);
            // return data;
            let news = state.news.filter(item => {
                let obj = item.cultures.find(p => p.id === id);
                return obj != undefined;
            });

            let articles = state.articles.filter(item => {
                let obj = item.cultures.find(p => p.id === id);
                return obj != undefined;
            });

            let promos = state.promos.filter(item => {
                let obj = item.cultures.find(p => p.id === id);
                return obj != undefined;
            });
            let arr = news.concat(articles);
            arr = arr.concat(promos);
            arr.sort((a, b) => b.date - a.date);
            return arr;
        },
        getProductRouteByName: (state) => (name) => {
            if(state.products.length) {
                let prod = state.products.filter( item => item.id == name);
                return prod[0].slug;
            }
           
        },
        getMaterialsByProduct: (state) => (id) => {
            if (!id) return [];
            let news = state.news.filter(item => {
                let obj = item.products.find(p => p === id);
                return obj != undefined;
            });

            let articles = state.articles.filter(item => {
                let obj = item.products.find(p => p === id);
                return obj != undefined;
            });

            let promos = state.promos.filter(item => {
                let obj = item.products.find(p => p === id);
                return obj != undefined;
            });

            let video = state.videos.filter(item => {
              let obj = item.products.find(p => p.id === id);
              return obj != undefined;
            });

            let arr = news.concat(articles);
            arr = arr.concat(promos);
            arr = arr.concat(video);
            arr.sort((a, b) => b.date - a.date);
            return arr;
        },
        getLastNews: (state) => (id) => {
            return state.news.filter(item => item.id != id);
        },
        getLastArticles: (state) => (id) => {
            return state.articles.filter(item => item.id != id);
        },
        getVideoBySlug: (state) => (slug) => {
            return state.videos.find(item => item.slug === slug);
        },
        getFieldNewsByYears: (state) => {
            let result = {};
            state.field_news.forEach(item => {
                let d = new Date(item.date);
                let y = d.getFullYear();
                if (result.hasOwnProperty(y)) {
                    result[y].posts.push(item);
                } else {
                    result[y] = {};
                    result[y].year = y;
                    result[y].posts = [];
                    result[y].posts.push(item);
                }
            });

            let arr = Object.values(result);
            arr.sort((a, b) => {return b.year - a.year});
            // arr.forEach(item => {
            //     item.posts.sort((a, b) => {return a.number - b.number});
            // })

            return arr;
        },
        getCulturesByDisease: (state) => (id) => {
            let ids = [];
            let cultures = state.diseases_by_culture.filter(item => {
                let obj = item.diseases.find(d => d.id === id);
                return obj != undefined;
            });
            cultures.forEach(item => {
                ids.push(item.id);
            });
            return state.cultures.filter(item => ids.indexOf(item.id) != -1);
        },
        getCatalogById: (state) => (id) => {
            return state.catalogs.find(item => item.id === id);
        },
        getCulturesWithDiseasesBySlug: (state) => (slug) => {
            return state.diseases_by_culture.find(item => item.slug === slug);
        },
        getCulturesWithDiseases: (state) => {
            return state.diseases_by_culture.filter(item => item.diseases.length);
        },
        getPostBySlug: (state) => (type, slug) => {
            return state[type].find(item => item.slug === slug);
        },
        getPromosForIndex: (state) => {
            return state.promos.filter(item => item.show_on_index === true);
        },
        getWeedBySlug: (state) => (slug) => {
            return state.weeds.find(item => item.slug === slug);
        },
        getPestBySlug: (state) => (slug) => {
            return state.pests.find(item => item.slug === slug);
        },
        getSiblings: (state) => (id, catalogs) => {
            let result = {prev: {}, next: {}};
            let arr = state.products.filter(item => item.catalogs[0] === catalogs);
            let i = arr.findIndex(item => {
                return item.id === id;
            });
            
            if (i != 0 && i != arr.length-1) {
                result.prev = arr[i-1];
                result.next = arr[i+1];
            }

            if (i === 0) {
                result.prev = arr[arr.length-1];
                result.next = arr[i+1];
            }

            if (i === arr.length-1) {
                result.prev = arr[i-1];
                result.next = arr[0];
            }

            return result;
        },
        getProductsCatalogs: (state) => {
            let arr = [];

            if(state.newProducts.length){
                newProductCatalog.color = state.settings.color_new_products;
                arr.push(newProductCatalog)
            }

            state.catalogs.forEach(item => {
                let obj = state.products.find(p => p.catalogs.indexOf(item.id) != -1);
                
                if (obj) {
                    arr.push(item);
                }
            });

            return arr;
        },
        getCulturesByIds: (state) => (ids) => {
            let result = [];
            if (!ids) return result;
            ids.forEach(item => {
                let obj = state.cultures.find(c => c.id === item);
                if (obj) result.push(obj);
            });
            return result;
        },
        getProductsByIds: (state) => (ids) => {
            let result = [];
            if (!ids) return result;
            ids.forEach(item => {
                let obj = state.products.find(c => c.id === item.id);
                if (obj) result.push(obj);
            });
            result.forEach(item => {
                let catalog = state.catalogs.find(c => c.id === item.catalogs[0]);
                if (catalog) item.category = {name: catalog.name, color: catalog.color}
            });
            return result;
        },
        getProductBySlug: (state) => (slug) => {
            return state.products.find(item => item.slug === slug);
        },
        getMaterialsBySlug: (state) => (slug) => {
            // let mass = [];
           
            if(state.articles.length) {
                let test = state.articles.filter( item => item.cultures[0].slug == slug );
                return test;
                // state.articles.forEach(item => {
                //     item.cultures ? 
                // })
            }
            // if(state.news.length) mass.push(state.news.filter( item => item.cultures.slug == slug));
            // console.log(mass);
            // return mass;
        },
        getProductsByCategory: (state) => (category) => {       
            if (!category) return state.products;

            if (category === newProductCatalog.slug || category === newProductCatalog.id) {
                return state.newProducts;
            }

            return state.products.filter(item => {
                return item.catalogs.indexOf(category) != -1;
            });
        },
        getCategoryBySlug: (state) => (slug) => {
            if(slug === newProductCatalog.slug || slug === newProductCatalog.id) return newProductCatalog;
            return state.catalogs.find(item => item.slug === slug);
        },
        getRegions: (state) => {
            let arr = [];
            state.regions.forEach(item => {
                let obj = state.managers.find(m => m.regions.indexOf(item.id) != -1);
                if (obj) {
                    arr.push(item);
                }
            });
            return arr;
        },
        getRegionBySlug: (state) => (slug) => {
            return state.regions.find(item => {
                return item.slug == slug;
            });
        },
        getManagersByRegion: (state) => (region) => {
            if (!region) return state.managers;
            return state.managers.filter(item => {
                return item.regions.indexOf(region) != -1;
            });
        },
        getCultureBySlug: (state) => (slug) => {
            return state.cultures.find(item => item.slug === slug);
        },
        getCropById: (state) => (id) => {
            let mass;
            mass = state.crop.filter(item => item.culture == id);
            // console.log(mass[0]);
            return mass.length ? mass[0] : [];
        },
        getBannerStatus: (state) => {
          return state.withBanner;
        },
        getDesk: (state) => {
          return state.desk;
        }
    },
	actions: {
        GET_COLLECTION: async (context, slug) => {
            let {data} = await $api.collection.get(slug);
            context.commit('SET_COLLECTION', {name: slug, data: data});
        },
        GET_NEW_PRODUCTS: async (context, slug) => {
            let {data} = await $api.collection.get("products/new-products");
            context.commit('SET_COLLECTION', {name: slug, data: data});
        },
        GET_SETTINGS: async (context) => {
            let {data} = await $api.settings.get();
            context.commit('SET_COLLECTION', {name: 'settings', data: data});
        },
        SEARCH_PRODUCTS: async (context, q) => {
            let {data} = await $api.search(q);
            context.commit('SET_COLLECTION', {name: 'searchProducts', data: data});
        },
        GET_CROP: async (context) => {
            let {data} = await $api.crop();
            context.commit('SET_CROP', data);
        },
        GET_ACTIVE_CULTURE: async (context, id) => {
            let {data} = await $api.culture.get(id);
            context.commit('SET_ACTIVE_CULTURE', data);
        },
        ACTIVATED_BANNER: async (context) => {
            context.commit('SET_BANNER', true);
        },
        HIDE_BANNER: async (context) => {
            context.commit('SET_BANNER', false);
        },
        CHANGE_DESK: async (context, status) => {
            context.commit('SET_DESKTOP', status);
        }
    },
});
